import { render, staticRenderFns } from "./JobFiles.yaml?vue&type=template&id=087cc406&component"
import script from "./JobFiles.yaml?vue&type=script&lang=ts&component"
export * from "./JobFiles.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports